const nbTranslations = {
    laanerammeTekst: {
        boliglaanKalkulator: 'Boliglånskalkulator',
        hvorMyeKanJegLaane: 'Hvor mye kan jeg låne?',
        hvaKosterLaanet: 'Hva koster lånet?',
        antallLaantakere: 'Antall låntakere',
        antallBarn: 'Antall barn under 18 år',
        antallBiler: 'Antall biler',
        ingen: 'Ingen',
        samletAarsinntektFoerSkatt: 'Samlet årsinntekt før skatt',
        samletGjeld: 'Samlet gjeld',
        samletGjeldSublabel: 'Du trenger ikke føre opp gjeld som innfris ved utbetaling av nytt boliglån.',
        laanerammeSpoersmaal: 'Fyll ut feltene for å se hvor mye vi tror du kan låne.',
        laanerammeSvar: 'Vi tror du kan låne',
        laanerammeSvarIkkeLaan: 'Basert på de valgte verdiene ser det ikke ut til at vi kan tilby lån.',
        laanerammeFeilmelding: 'Vi klarer ikke å hente hvor mye du kan låne, prøv igjen seinere.',
        soekBoliglaan: 'Søk boliglån',
    },
    laanekostnadTekst: {
        annen: 'Annen',
        aar: 'år',
        maanedligKostnad: 'Månedlig kostnad',
        nedbetalingstid: 'Nedbetalingstid',
        nedbetalingstidRequired: 'Vennligst fyll ut dette feltet',
        nedbetalingstidError: 'Nedbetalingstid må være mindre enn eller lik 30 år',
        oensketLaanebeloep: 'Ønsket lånebeløp',
        oensketNedbetalingstid: 'Ønsket nedbetalingstid',
        rentePaaLaanet: 'Rente på lånet',
        rentePaaLaanetSubLabel: 'Din økonomi må tåle en renteøkning på minimum 3%',
        renteTilbakestill: 'Tilbakestill rente',
        vent: 'Vent...',
    },
    nedbetalingsplanTekst: {
        nedbetalingsplan: 'Nedbetalingsplan',
        lukk: 'Lukk',
        lukkNedbetalingsplan: 'Lukk nedbetalingsplan',
        visNedbetalingsplan: 'Vis nedbetalingsplan',
        aar: 'År',
        aaBetale: 'Å betale',
        avdrag: 'Avdrag',
        renterOgGebyr: 'Renter og gebyrer',
        restgjeld: 'Restgjeld',
    },
    ok: 'Ok',
};
export default nbTranslations;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmJUcmFuc2xhdGlvbnMtY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RyYW5zbGF0aW9ucy9uYlRyYW5zbGF0aW9ucy1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxjQUFjLEdBQTJCO0lBQzNDLGVBQWUsRUFBRTtRQUNiLG1CQUFtQixFQUFFLHFCQUFxQjtRQUMxQyxrQkFBa0IsRUFBRSx3QkFBd0I7UUFDNUMsZUFBZSxFQUFFLG1CQUFtQjtRQUNwQyxnQkFBZ0IsRUFBRSxrQkFBa0I7UUFDcEMsVUFBVSxFQUFFLHlCQUF5QjtRQUNyQyxXQUFXLEVBQUUsY0FBYztRQUMzQixLQUFLLEVBQUUsT0FBTztRQUNkLDBCQUEwQixFQUFFLDZCQUE2QjtRQUN6RCxXQUFXLEVBQUUsY0FBYztRQUMzQixtQkFBbUIsRUFBRSw2RUFBNkU7UUFDbEcsb0JBQW9CLEVBQUUsd0RBQXdEO1FBQzlFLGNBQWMsRUFBRSxxQkFBcUI7UUFDckMsc0JBQXNCLEVBQUUsdUVBQXVFO1FBQy9GLHFCQUFxQixFQUFFLGtFQUFrRTtRQUN6RixhQUFhLEVBQUUsY0FBYztLQUNoQztJQUNELGlCQUFpQixFQUFFO1FBQ2YsS0FBSyxFQUFFLE9BQU87UUFDZCxHQUFHLEVBQUUsSUFBSTtRQUNULGdCQUFnQixFQUFFLGtCQUFrQjtRQUNwQyxlQUFlLEVBQUUsaUJBQWlCO1FBQ2xDLHVCQUF1QixFQUFFLGdDQUFnQztRQUN6RCxvQkFBb0IsRUFBRSxvREFBb0Q7UUFDMUUsa0JBQWtCLEVBQUUsa0JBQWtCO1FBQ3RDLHNCQUFzQixFQUFFLHdCQUF3QjtRQUNoRCxjQUFjLEVBQUUsZ0JBQWdCO1FBQ2hDLHNCQUFzQixFQUFFLGtEQUFrRDtRQUMxRSxpQkFBaUIsRUFBRSxvQkFBb0I7UUFDdkMsSUFBSSxFQUFFLFNBQVM7S0FDbEI7SUFDRCxxQkFBcUIsRUFBRTtRQUNuQixnQkFBZ0IsRUFBRSxrQkFBa0I7UUFDcEMsSUFBSSxFQUFFLE1BQU07UUFDWixvQkFBb0IsRUFBRSx1QkFBdUI7UUFDN0MsbUJBQW1CLEVBQUUsc0JBQXNCO1FBQzNDLEdBQUcsRUFBRSxJQUFJO1FBQ1QsUUFBUSxFQUFFLFVBQVU7UUFDcEIsTUFBTSxFQUFFLFFBQVE7UUFDaEIsYUFBYSxFQUFFLG1CQUFtQjtRQUNsQyxTQUFTLEVBQUUsV0FBVztLQUN6QjtJQUNELEVBQUUsRUFBRSxJQUFJO0NBQ1gsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=